<!-- 新闻 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_news.png"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="新闻事件" en="NEWS EVENT"></sub-title>
        <div class="list" v-if="list.length != 0">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="getDetail(item)"
          >
            <div class="post">
              <img :src="URL + item.newsImageUrl" alt="" />
            </div>
            <div class="right">
              <div class="top">
                <div class="title">{{ item.title }}</div>
                <div class="time">
                  {{ (item.publishTime || item.createTime) | handleTime }}
                </div>
              </div>
              <div class="line"></div>
              <div class="desc">{{ item.description }}</div>
              <div class="more">查看详情 >>></div>
            </div>
          </div>
          <div class="full">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="queryParams.pageIndex"
              :page-size="queryParams.pageSize"
              layout="total, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <el-empty description="暂无案例" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "6565a1a8655b44499be838a8916870f8",
      },
      list: [],
      total: 0,
      bannerList: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.getList();
    this.formatBreadCrumb();
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      let res = await this.$api.getBannerList({ type: 1 });
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBannerSwiper();
      }, 10);
    },
    // 初始化banner swiper
    initBannerSwiper() {
      new window.Swiper("#banner", {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getNewsList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    getDetail(item) {
      window.scrollTo({ top: 200 });
      this.$router.push("/news/newDetail/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    height: 600px;
    object-fit: cover;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/news_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 120px;

    .list {
      margin-top: 40px;

      .item {
        display: flex;
        margin-bottom: 90px;
        cursor: pointer;

        &:hover {
          .post img {
            transform: scale(1.1);
          }
        }
        &:nth-child(2n) {
          flex-direction: row-reverse;

          .right {
            margin-left: 0;
            margin-right: 40px;
          }
        }
        .post {
          flex-shrink: 0;
          width: 520px;
          height: 340px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.5s;
          }
        }
        .right {
          flex-grow: 1;
          margin-left: 40px;
          position: relative;

          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .title {
            width: 400px;
            font-size: 18px;
            font-weight: bold;
            color: $theme;
            line-height: 30px;
            @include mutipleEllipsis(2);
          }
          .time {
            margin-top: 10px;
            font-size: 14px;
            color: #9c9b9b;
            padding-bottom: 10px;
          }
          .line {
            width: 29px;
            height: 2px;
            background-color: $theme;
            margin: 40px 0;
          }
          .desc {
            text-indent: 2em;
            font-size: 15px;
            color: #5e5d5d;
            line-height: 30px;
            @include mutipleEllipsis(5);
          }
          .more {
            color: #053a7a;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
      }
      .full {
        width: 100%;
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .list {
        margin-top: 20px;

        .item {
          margin-bottom: 20px;
          display: block;

          &:nth-child(2n) {
            .right {
              margin-right: 0;
            }
          }
          .post {
            width: 100%;
            height: 220px;
          }
          .right {
            margin-left: 0;

            .title {
              width: 70%;
            }
            .line {
              margin: 10px 0;
            }
            .desc {
              font-size: 14px;
            }
            .more {
              position: static;
              text-align: right;
              font-size: 14px;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
